import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Input } from '@/components/ui';

interface GISCoordEditorProps {
  onSubmit: (geom: GeoJSON.Geometry) => void;
  pending: boolean;
}

export function GISCoordEditor({ onSubmit, pending }: GISCoordEditorProps) {
  const { t } = useTranslation('studio');
  const [lon, setLon] = useState('');
  const [lat, setLat] = useState('');

  const valid = isFiniteNum(lon) && isFiniteNum(lat);
  const lonN = parseFloat(lon);
  const latN = parseFloat(lat);
  const inRange =
    valid && lonN >= -180 && lonN <= 180 && latN >= -90 && latN <= 90;

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (inRange) onSubmit({ type: 'Point', coordinates: [lonN, latN] });
      }}
      className="space-y-3"
    >
      <div className="grid grid-cols-2 gap-3">
        <label className="block text-small">
          <span className="text-slate-700">{t('gis.editor.coords.lon')}</span>
          <Input
            type="number"
            step="any"
            min={-180}
            max={180}
            value={lon}
            onChange={(e) => setLon(e.target.value)}
            placeholder="-6.2928"
            inputMode="decimal"
          />
        </label>
        <label className="block text-small">
          <span className="text-slate-700">{t('gis.editor.coords.lat')}</span>
          <Input
            type="number"
            step="any"
            min={-90}
            max={90}
            value={lat}
            onChange={(e) => setLat(e.target.value)}
            placeholder="36.5297"
            inputMode="decimal"
          />
        </label>
      </div>
      <p className="text-small text-slate-500">{t('gis.editor.coords.polygonHint')}</p>
      <div className="flex justify-end">
        <Button type="submit" disabled={!inRange || pending}>
          {t('gis.editor.save')}
        </Button>
      </div>
    </form>
  );
}

function isFiniteNum(s: string): boolean {
  const n = parseFloat(s);
  return s.trim() !== '' && Number.isFinite(n);
}
